require('/opt/odin/app/frontend/components/shadow_header/index.module.scss');module.exports = "../../app/cells/components/shadow_header/show.erb";